// extracted by mini-css-extract-plugin
module.exports =  {"messageContainer":"messageContainer_MfBOg2ee"};